export class ReduccionUsuario{
  cantidad_reduccion:number=0;
  cantidad_total_usuarios:number=0;
  codigo_modulo:string='';
  es_decremento:boolean= true;
  fecha_registro:string=''
}
